import type { ProjectItem } from '@store/reducers/dashboard/types'
import type React from 'react'

import { useProjectLabel } from '../../../../hooks'
import { UpdateDot } from '../../../UpdateDot'
import css from './styles.module.css'

interface Props {
  project: ProjectItem
}

export const ProjectLabel: React.FC<Props> = ({ project }) => {
  const { title, updated } = useProjectLabel(project)

  return (
    <div className={css.project_label}>
      <div className={css.title_row}>
        <div className={css.project_title}>{title}</div>
        {project.type === 'report' && project.hasUpdate && <UpdateDot />}
      </div>
      <div className={css.project_date}>{updated}</div>
    </div>
  )
}
